<template>
    <div>
          <el-button type="primary" @click="invalidateCache" size="mini" icon="el-icon-delete" round>Invalidate Preset Cache</el-button>
    </div>    
</template>
<script>
export default {
    name: 'personalization',
    methods: {
        async invalidateCache() {
            try {
            await this.$api.post(`/personalization/invalidate_caches`);

                this.$notify.success({
                    title: 'Cache invalidated successfully',
                });
            } catch (e) {
                this.$notify.error({
                    title: 'Failed Cache invalidation',
                });
            }
        }
    }
}
</script>